export default "__VITE_ASSET__BbFP0kmH__"